import { useEffect, useState } from 'react';
import api from './api';

const fallbackServices = [
  { _id: 'fallback-1', title: 'البرامج المحاسبية', description: 'حلول محاسبية متكاملة لإدارة الحسابات والفواتير والضرائب والتقارير المالية بدقة.', category: 'محاسبة', iconKey: 'calculator', colorKey: 'green', features: ['إدارة الحسابات', 'الفواتير الإلكترونية', 'تقارير مالية', 'إدارة الضرائب'], active: true, order: 1 },
  { _id: 'fallback-2', title: 'الأنظمة الطبية', description: 'أنظمة لإدارة المستشفيات والعيادات والمرضى والمواعيد والسجلات الطبية.', category: 'طبية', iconKey: 'hospital', colorKey: 'red', features: ['إدارة المرضى', 'المواعيد', 'السجلات الطبية', 'الفواتير الطبية'], active: true, order: 2 },
  { _id: 'fallback-3', title: 'أنظمة المقاولات', description: 'حلول لإدارة مشاريع المقاولات والمواقع والمستخلصات والتكاليف والعمالة.', category: 'مقاولات', iconKey: 'construction', colorKey: 'orange', features: ['إدارة المشاريع', 'التكاليف', 'المستخلصات', 'متابعة المواقع'], active: true, order: 3 },
  { _id: 'fallback-4', title: 'أنظمة العقارات', description: 'إدارة العقارات والوحدات والعقود والإيجارات والصيانة من مكان واحد.', category: 'عقارات', iconKey: 'building', colorKey: 'blue', features: ['إدارة الوحدات', 'العقود', 'الإيجارات', 'الصيانة'], active: true, order: 4 },
  { _id: 'fallback-5', title: 'تطبيقات الجوال', description: 'تطوير تطبيقات احترافية لنظامي iOS وAndroid بتجربة استخدام سريعة وحديثة.', category: 'تطبيقات جوال', iconKey: 'smartphone', colorKey: 'purple', features: ['iOS و Android', 'إشعارات فورية', 'واجهات عربية', 'تكامل API'], active: true, order: 5 },
  { _id: 'fallback-6', title: 'التجارة الإلكترونية', description: 'متاجر إلكترونية متكاملة مع بوابات الدفع وإدارة المنتجات والطلبات والعملاء.', category: 'تجارة إلكترونية', iconKey: 'shopping', colorKey: 'cyan', features: ['إدارة المنتجات', 'بوابات الدفع', 'الطلبات', 'التقارير'], active: true, order: 6 },
];

export default function useServices() {
  const [services, setServices] = useState(fallbackServices);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api.get('/services')
      .then(({ data }) => {
        if (mounted && Array.isArray(data)) setServices(data);
      })
      .catch(() => {})
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  return { services, loading };
}
